import { FC, useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useApi } from '@repo-level/core-front';

import { AddonsContext } from 'contexts/addons';
import { registrationBanner as fetchRegistrationBanner } from 'api/cms/registrationBanner';
import { useIsVipBenefits } from 'hooks/vipBenefits';
import { Spinner } from 'components/Spinner';
import { VipBenefitsRegistrationBanner } from './VipBenefitsRegistrationBanner';

import { ScRegistrationBanner } from '../styled';

export const RegistrationBanner: FC = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const { customOffer } = useContext(AddonsContext);
  const customBonusOffer = useMemo(
    () => (customOffer?.bonuses ? customOffer.bonuses[0].offer : null),
    [customOffer]
  );

  const isVipBenefits = useIsVipBenefits();

  const [
    requestRegistrationBanner,
    { data: registrationBanner, pending: pendingRegistrationBanner },
  ] = useApi(fetchRegistrationBanner);

  useEffect(() => {
    requestRegistrationBanner(language);
  }, [requestRegistrationBanner, language]);

  return (
    <ScRegistrationBanner isVipBenefits={isVipBenefits}>
      {pendingRegistrationBanner ? (
        <Spinner size={32} />
      ) : (
        <>
          {registrationBanner &&
            (isVipBenefits ? (
              <VipBenefitsRegistrationBanner />
            ) : (
              <div className="offers">
                <div className="title">{registrationBanner.title}</div>
                <div className="offer">
                  {customBonusOffer ? (
                    <p>{customBonusOffer}</p>
                  ) : (
                    <>
                      <p>{registrationBanner.offerLine_1}</p>
                      {registrationBanner.offerLine_2 && (
                        <p>{registrationBanner.offerLine_2}</p>
                      )}
                    </>
                  )}
                </div>
              </div>
            ))}
        </>
      )}
    </ScRegistrationBanner>
  );
};
